export function useAiApiHost(): string | null {
  const hostEl = document.getElementById('ai-api-host');

  if (hostEl && hostEl instanceof HTMLMetaElement) {
    return hostEl.content;
  }
  return null;
}
